export const Arrow = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={13}
            viewBox="0 0 14 13"
            fill="none"
        >
            <path d="M7 0.5L13.9282 12.5H0.0717969L7 0.5Z" fill="#262626" />
        </svg>

    )
}